import defaultState from './state'
import mutations from './mutations'

const googlemap = {
  namespaced: true,
  state: {
    ...defaultState,
  },
  mutations,
}

export default googlemap



// WEBPACK FOOTER //
// ./src/store/googlemap/index.js